import React from "react"
import { graphql } from "gatsby"
import CaseStudyTemplate from "../../../components/caseStudies/CaseStudyTemplate"
import data from "../../../data/caseStudies/hushPuppiesPakistan"

const HushPuppiesPakistan = ({ data: queryData }) => (
  <CaseStudyTemplate
    {...data}
    heroImage={queryData.heroImage?.childImageSharp?.gatsbyImageData}
  />
)

export default HushPuppiesPakistan

export const query = graphql`
  query HushPuppiesPakistanCaseStudyImages {
    heroImage: file(relativePath: { eq: "caseStudies/hushPuppiesPakistan-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
